import education from "../data/education";

const Education = () => {
  return (
    <section id="education" className="section">
      <div className="container">
        <h2 className="headline-2 reveal-up">Education</h2>
        <p className="text-zinc-400 mt-3 mb-8 max-w-[50ch] reveal-up">
          Academic and professional learning that shaped my foundation in
          software engineering and modern development practices.
        </p>

        <div className="flex flex-col gap-6">
          {education.map(
            ({
              degree,
              institution,
              program,
              institutionUrl,
              logoSrc,
              startDate,
              endDate,
              location,
              highlights,
            }) => (
              <article
                key={`${institution}-${startDate}`}
                className="bg-zinc-800/50 p-7 rounded-2xl md:p-10 reveal-up"
              >
                <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between md:gap-8 mb-5">
                  <div className="flex items-start gap-4">
                    {logoSrc && (
                      <figure className="bg-zinc-700/50 rounded-xl overflow-hidden w-12 h-12 shrink-0 p-1.5">
                        <img
                          src={logoSrc}
                          alt={`${institution} logo`}
                          width={48}
                          height={48}
                          loading="lazy"
                          className="w-full h-full object-contain"
                        />
                      </figure>
                    )}

                    <div>
                      <h3 className="text-lg font-semibold text-zinc-100 md:text-xl">
                        {degree}
                      </h3>
                      <p className="mt-1 text-zinc-300">
                        {institutionUrl ? (
                          <a
                            href={institutionUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="text-sky-400 transition-colors hover:text-sky-300"
                          >
                            {institution}
                          </a>
                        ) : (
                          <span className="text-sky-400">{institution}</span>
                        )}
                        <span className="text-zinc-500"> | </span>
                        {program}
                      </p>
                    </div>
                  </div>

                  <div
                    className={`text-sm text-zinc-400 md:text-right shrink-0 ${
                      logoSrc ? "pl-16 md:pl-0" : ""
                    }`}
                  >
                    <p>
                      {startDate} – {endDate}
                    </p>
                    <p>{location}</p>
                  </div>
                </div>

                <ul className="flex flex-col gap-3 text-zinc-300 text-sm md:text-base">
                  {highlights.map((item) => (
                    <li key={item} className="flex gap-3">
                      <span className="text-sky-400 mt-1.5 shrink-0">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </article>
            )
          )}
        </div>
      </div>
    </section>
  );
};

export default Education;
